import React from 'react';
import { motion } from 'framer-motion';
interface PageBannerProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
}
export function PageBanner({
  title,
  subtitle,
  backgroundImage
}: PageBannerProps) {
  return <section className="relative pt-32 pb-20 bg-gradient-to-br from-burgundy via-brown to-jet flex items-center justify-center overflow-hidden" data-id="element-217">
      {/* Background Image */}
      {backgroundImage && <div className="absolute inset-0" data-id="element-218">
          <img src={backgroundImage} alt="" className="w-full h-full object-cover" data-id="element-219" />
          <div className="absolute inset-0 bg-gradient-to-br from-burgundy/85 via-brown/80 to-jet/90" data-id="element-220"></div>
        </div>}

      {/* Pattern Overlay */}
      <div className="absolute inset-0 pattern-african opacity-20 mix-blend-overlay" data-id="element-221"></div>

      {/* Decorative Elements */}
      <div className="absolute top-1/4 left-10 w-32 h-32 border border-golden/20 rounded-full blur-sm" data-id="element-222"></div>
      <div className="absolute bottom-1/4 right-10 w-64 h-64 border border-golden/10 rounded-full blur-md" data-id="element-223"></div>

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-224">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-6xl font-heading font-bold text-cream mb-4 text-glow" data-id="element-225">
          {title}
        </motion.h1>
        {subtitle && <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-beige/90 font-light" data-id="element-226">
            {subtitle}
          </motion.p>}
      </div>

      {/* Bottom decorative divider */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-golden to-transparent opacity-50" data-id="element-227"></div>
    </section>;
}